import { Checkbox } from '@consta/uikit/Checkbox'
import { Combobox } from '@consta/uikit/Combobox'
import { Select } from '@consta/uikit/Select'
import { Text } from '@consta/uikit/Text'
import type { TextFieldPropOnChange } from '@consta/uikit/TextField'
import { TextField } from '@consta/uikit/TextField'
import type {
  ColumnSeparator,
  FileEncoding,
  MarkerSetupType,
  OptionItemType,
} from '@core/core/types'
import type { FC } from 'react'

import css from './Setup.css'
import { encodingOptions, separatorOptions } from './types'

export const PropertiesPanel: FC<{
  settings: MarkerSetupType
  update: (value: Partial<MarkerSetupType>) => void
}> = ({ settings, update }) => {
  // используется в законсервированном коде
  const { missedLinesCount, timeZone, separator, /* units, */ negativeZ, negativeTWT, encoding } =
    settings

  const setComboboxValue = () => {
    return
  }

  const onMissedLinesCountChange: TextFieldPropOnChange = value => {
    if (value !== null) {
      update({ missedLinesCount: parseInt(value, 10) })
    }
  }

  const onSeparatorChange = (value: OptionItemType<ColumnSeparator> | null) => {
    if (value) {
      update({ separator: value.name })
    }
  }

  const onEncodingChange = (value: OptionItemType<FileEncoding> | null) => {
    if (value) {
      update({ encoding: value.name })
    }
  }

  const onNegativeZChange = () => {
    update({ negativeZ: !negativeZ })
  }

  const onNegativeTWTChange = () => {
    update({ negativeTWT: !negativeTWT })
  }

  return (
    <div>
      <div className={css.rowWrapper}>
        <div className={css.fullWidth}>
          <Text size="s" view="secondary" className={css.textPadding}>
            Пропустить строки
          </Text>
          <TextField
            data-testid="settings-missedLinesCount"
            size="s"
            className={css.fullWidth}
            type="number"
            value={missedLinesCount.toString()}
            min={0}
            onChange={onMissedLinesCountChange}
          />
        </div>
        <div className={css.fullWidth}>
          <Text size="s" view="secondary" className={css.textPadding}>
            Система координат файла
          </Text>
          <Combobox
            data-testid="settings-coordinatesSystem"
            size="s"
            items={[timeZone]}
            value={timeZone}
            getItemKey={item => item}
            getItemLabel={item => item}
            status={!timeZone ? 'alert' : undefined}
            disabled={true}
            onChange={setComboboxValue}
          />
        </div>
      </div>
      <div className={css.rowWrapper}>
        <div className={css.fullWidth}>
          <Text size="s" view="secondary" className={css.textPadding}>
            Разделитель
          </Text>
          <Select
            data-testid="settings-separator"
            size="s"
            items={separatorOptions}
            value={separatorOptions.find(option => option.name === separator)}
            getItemKey={item => item.name}
            getItemLabel={item => item.label}
            onChange={onSeparatorChange}
          />
        </div>
        {/* Понадобится в будущем наверное */}
        {/* <div className={css.fullWidth}>
          <Text size="s" view="secondary" className={`${css.unitsTitle} {css.textPadding}`}>
            Единицы измерения глубины
          </Text>
          <Combobox
            size="s"
            items={[units]}
            value={units}
            getItemKey={item => item}
            getItemLabel={item => item}
            status={!units ? 'alert' : undefined}
            disabled={true}
            onChange={setComboboxValue}
          />
        </div> */}
        <div className={css.fullWidth}>
          <Text size="s" view="secondary" className={css.textPadding}>
            Кодировка
          </Text>
          <Select
            data-testid="settings-encoding"
            size="s"
            items={encodingOptions}
            value={encodingOptions.find(option => option.name === encoding)}
            getItemKey={item => item.name}
            getItemLabel={item => item.label}
            className={css.select}
            onChange={onEncodingChange}
          />
        </div>
      </div>
      <div className={css.checkboxContainer}>
        <Checkbox
          data-testid="settings-negativeZ"
          label="Отрицательные значения Z"
          checked={negativeZ}
          className={`${css.checkboxLabel} ${css.negativeZ}`}
          onChange={onNegativeZChange}
        />
      </div>
      <div className={css.checkboxContainer}>
        <Checkbox
          data-testid="settings-negativeTWT"
          label="Отрицательные значения TWT"
          checked={negativeTWT}
          className={`${css.checkboxLabel} ${css.negativeTwt}`}
          onChange={onNegativeTWTChange}
        />
      </div>
    </div>
  )
}
